import { useState } from 'react';

export function BeforeAfter({ before, after }: { before: string; after: string }) {
  const [position, setPosition] = useState(52);
  // نسبت ابعاد واقعی عکس مرجع خوانده می‌شود تا کادر دقیقاً هم‌نسبت خود عکس ساخته شود و
  // کناره‌های آن نوار خالی (letterbox) نماند. عکس طراحی‌شده هم از روی همین عکس ساخته
  // می‌شود و هم‌نسبت آن است.
  const [ratio, setRatio] = useState<number | null>(null);
  // نسبت کادر مبنا را عکس «طراحی نهایی» تعیین می‌کند (محتوای اصلی این بخش) و تا لود
  // شدن آن، عکس اصلی جایگزین موقت است؛ کادر همیشه هم‌نسبت عکسِ نمایش‌داده‌شده ساخته
  // می‌شود تا بدون زوم/برش، کامل جا بگیرد.
  const adoptRatio = (naturalWidth: number, naturalHeight: number, preferred = false) => {
    if (naturalWidth > 0 && naturalHeight > 0) setRatio((prev) => (preferred || prev === null) ? naturalWidth / naturalHeight : prev);
  };
  const onImageLoad = (event: React.SyntheticEvent<HTMLImageElement>, preferred = false) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    adoptRatio(naturalWidth, naturalHeight, preferred);
  };
  // عکس‌های کش‌شده ممکن است پیش از وصل‌شدن ref آماده باشند؛ onLoad برای آن‌ها نمی‌آید.
  const captureRatio = (image: HTMLImageElement | null, preferred = false) => {
    if (image?.complete) adoptRatio(image.naturalWidth, image.naturalHeight, preferred);
  };
  return <div className="comparison" style={{ '--position': `${position}%`, ...(ratio ? { '--ar': `${ratio}` } : {}) } as React.CSSProperties}>
    <img src={before} alt="تصویر اصلی اتاق" ref={(image) => captureRatio(image)} onLoad={(event) => onImageLoad(event)} />
    <div className="after-layer"><img src={after} alt="طراحی نهایی اتاق" ref={(image) => captureRatio(image, true)} onLoad={(event) => onImageLoad(event, true)} /></div>
    <div className="compare-line"><span>↔</span></div>
    <input aria-label="مقایسه تصویر قبل و بعد" type="range" min="0" max="100" value={position} onChange={(event) => setPosition(Number(event.target.value))} />
    <span className="compare-label before">بعد</span><span className="compare-label after">قبل</span>
  </div>;
}
